import { SortingState } from '@tanstack/react-table';

import { SortOrder } from './types';

export function mapToSortOrder(tableSortBy: SortingState) {
  return tableSortBy.reduce((acc, curr, index) => {
    acc[curr.id] = {
      priority: index,
      // eslint-disable-next-line i18next/no-literal-string -- not user-visible
      direction: curr.desc ? 'DESC' : 'ASC',
    };
    return acc;
  }, {} as SortOrder);
}
